import {
    GET_PERIODS_ACTION_FETCH,
    LOCK_PERIOD_ACTION,
    UNLOCK_PERIOD_ACTION,
    SET_PERIOD_ACTION,
    OPEN_PERIOD_ACTION,
    PERIOD_SEND_NOTIFICATION_CLEAR
} from './constants';
import {Period, OnOpenPeriodFailure} from './typedef';

export const getPeriodsAction = () => ({
    type: GET_PERIODS_ACTION_FETCH
});

export const setPeriodAction = (period: Period) => ({
    type: SET_PERIOD_ACTION,
    data: period
});

export const lockPeriodAction = (id: number) => {
    return {
        type: LOCK_PERIOD_ACTION,
        id
    };
};

export const unlockPeriodAction = (id: number) => {
    return {
        type: UNLOCK_PERIOD_ACTION,
        id
    };
};

export const openPeriodAction = (onOpenPeriodFailure: OnOpenPeriodFailure) => {
    return {
        type: OPEN_PERIOD_ACTION,
        onOpenPeriodFailure
    };
};

export const clearNotification = () => ({
    type: PERIOD_SEND_NOTIFICATION_CLEAR
});
